<template>
    <div class="insights-list-filters">
        <div class="insights-list-filters--loader" v-if="isLoading">
            <spinning-loader/>
        </div>
        <div class="insights-list-filters--error" v-else-if="errorMessage">
            {{ errorMessage }}
        </div>
        <form autocomplete="off"
                v-else
                ref="form"
                @submit="onSubmit">
            <div class="insights-list-filters--row">
                <div class="insights-list-filters--tag-search insights-list-filters--col">
                    <insight-tags-search :input-placeholder="inputPlaceholder"
                            :no-results-found-text="noResultsFoundText"
                            @submit-requested="onSubmit"/>
                </div>
                <div class="insights-list-filters--select insights-list-filters--col">
                    <ui-select :facets="['filters']"
                            name="industry"
                            :value="activeFilters.industry || ''"
                            @change="onSelectChange">
                        <ui-option value="">
                            {{ industrySelectPlaceholder }}
                        </ui-option>
                        <ui-option :value="industry.id"
                                v-for="industry in industries"
                                :key="industry.id">
                            {{ industry.title }}
                        </ui-option>
                    </ui-select>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import InsightTagsSearch from '../../components/insight-tags-search/insight-tags-search';
    import SpinningLoader from '../../components/loaders/spinning-loader/spinning-loader';
    import UiSelect from '@dreipol/vue-ui/src/components/form/select/select';
    import UiOption from '@dreipol/vue-ui/src/components/form/option/option';
    import UiOptgroup from '@dreipol/vue-ui/src/components/form/optgroup/optgroup';
    import { getOr } from 'lodash/fp';
    import { CancelToken } from 'axios';
    import { mapActions, mapState } from 'vuex';

    const getOrEmptyArray = getOr([]);
    const getIndustries = getOrEmptyArray('filters.industries');

    export default {
        components: {
            SpinningLoader,
            InsightTagsSearch,
            UiOption,
            UiSelect,
            UiOptgroup,
        },
        props: {
            inputPlaceholder: {
                type: String,
                required: true,
            },
            industrySelectPlaceholder: {
                type: String,
                required: true,
            },
            noResultsFoundText: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                errorMessage: null,
                isLoading: true,
            };
        },
        computed: {
            ...mapState('insights', ['availableFilters', 'activeFilters']),
            industries() {
                return getIndustries(this.availableFilters);
            },
        },
        methods: {
            ...mapActions('insights', ['fetchAvailableFilters', 'fetchInsights', 'resetInsights']),
            loadFilters() {
                return this.fetchAvailableFilters();
            },
            onSubmit(event) {
                event.preventDefault();

                // abort previous ajax requests
                if (this.cancelToken) {
                    this.cancelToken.cancel();
                }

                // blur the input field
                if (document.activeElement) {
                    document.activeElement.blur();
                }

                const formData = new FormData(this.$refs.form);
                const params = {};
                for (let [key, value] of formData.entries()) {
                    Object.assign(params, { [key]: value });
                }

                // create a cancellation token to abort this request
                this.cancelToken = CancelToken.source();

                this.resetInsights();
                this.fetchInsights({
                    params,
                    cancelToken: this.cancelToken.token,
                });
            },

            onSelectChange(event) {
                this.onSubmit(event);
            },
        },
        mounted() {
            const onSuccess = () => {
                this.isLoading = false;
            };
            const onError = (error) => {
                this.errorMessage = error.message;
            };

            this.loadFilters()
                .finally(onSuccess)
                .catch(onError);
        },
    };
</script>
